// Hook informs whether the HTML element was visible in the viewport
import {type RefObject, useEffect, useRef} from "react";

interface IElementRef {
    id: string;
    ref: RefObject<Element | null>;
}

interface IParams {
    ids: string[];
    elementRefs?: IElementRef[];
    indexes?: {[id: string]: number};
    once?: boolean; // call `onElementVisible` callback only once - regardless of the number of views
    onElementVisible: (id: string, entry: IntersectionObserverEntry, index?: number) => void;
    threshold?: number;
    disabled?: boolean;
}

export const useElementWasVisible = (params: IParams) => {
    const seen = useRef<string[]>([]);
    const elementRefIds = params.elementRefs?.map(({id}) => id) ?? [];

    useEffect(() => {
        if (params.disabled || !("IntersectionObserver" in window)) {
            return;
        }

        const elementIds = new Map<Element, string>();
        let isActive = true;
        const observer = new IntersectionObserver(
            (entries) => {
                if (!isActive) {
                    return;
                }

                entries.forEach((entry) => {
                    const id = elementIds.get(entry.target) ?? entry.target.getAttribute("data-id");

                    if (id === null) {
                        return;
                    }

                    if (entry.isIntersecting) {
                        if (params.once) {
                            if (!seen.current.includes(id)) {
                                seen.current = seen.current.concat(id);
                                params.onElementVisible(id, entry);
                                if (!!Number(id) && params.indexes) {
                                    params.onElementVisible(id, entry, params.indexes[id]);
                                }
                            }

                            return;
                        } else {
                            params.onElementVisible(id, entry);
                        }
                    }
                });
            },
            {threshold: [params.threshold ?? 1]} // `1` means full element was visible
        );

        const elements: Element[] = [];

        const observeElement = (id: string, element: Element | null) => {
            if (element === null) {
                return;
            }

            elementIds.set(element, id);
            observer.observe(element);
            elements.push(element);
        };

        params.ids.forEach((id) => {
            const element = document.querySelector(`[data-id="${id}"]`);

            observeElement(id, element);
        });

        params.elementRefs?.forEach(({id, ref}) => observeElement(id, ref.current));

        return () => {
            isActive = false;
            elements.forEach((element) => observer.unobserve(element));
        };
    }, [JSON.stringify(params.ids), JSON.stringify(elementRefIds), params.disabled]);
};
// Hook informs whether the HTML element was visible in the viewport
import {type RefObject, useEffect, useRef} from "react";

interface IElementRef {
    id: string;
    ref: RefObject<Element | null>;
}

interface IParams {
    ids: string[];
    elementRefs?: IElementRef[];
    indexes?: {[id: string]: number};
    once?: boolean; // call `onElementVisible` callback only once - regardless of the number of views
    onElementVisible: (id: string, entry: IntersectionObserverEntry, index?: number) => void;
    threshold?: number;
    disabled?: boolean;
}

export const useElementWasVisible = (params: IParams) => {
    const seen = useRef<string[]>([]);
    const elementRefIds = params.elementRefs?.map(({id}) => id) ?? [];

    useEffect(() => {
        if (params.disabled || !("IntersectionObserver" in window)) {
            return;
        }

        const elementIds = new Map<Element, string>();
        let isActive = true;
        const observer = new IntersectionObserver(
            (entries) => {
                if (!isActive) {
                    return;
                }

                entries.forEach((entry) => {
                    const id = elementIds.get(entry.target) ?? entry.target.getAttribute("data-id");

                    if (id === null) {
                        return;
                    }

                    if (entry.isIntersecting) {
                        if (params.once) {
                            if (!seen.current.includes(id)) {
                                seen.current = seen.current.concat(id);
                                params.onElementVisible(id, entry);
                                if (!!Number(id) && params.indexes) {
                                    params.onElementVisible(id, entry, params.indexes[id]);
                                }
                            }

                            return;
                        } else {
                            params.onElementVisible(id, entry);
                        }
                    }
                });
            },
            {threshold: [params.threshold ?? 1]} // `1` means full element was visible
        );

        const elements: Element[] = [];

        const observeElement = (id: string, element: Element | null) => {
            if (element === null) {
                return;
            }

            elementIds.set(element, id);
            observer.observe(element);
            elements.push(element);
        };

        params.ids.forEach((id) => {
            const element = document.querySelector(`[data-id="${id}"]`);

            observeElement(id, element);
        });

        params.elementRefs?.forEach(({id, ref}) => observeElement(id, ref.current));

        return () => {
            isActive = false;
            elements.forEach((element) => observer.unobserve(element));
        };
    }, [JSON.stringify(params.ids), JSON.stringify(elementRefIds), params.disabled]);
};
